import { FilterOption } from "@/types";


export const getOption = (name: string, options: FilterOption[]) => {
  return options.find(option => option.name === name)?.label || '';
}
